import { IsOptional, IsNotEmpty, ValidateNested, IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { AssetsCode } from '@gtpl/shared-models/common-models';
export class AssetsClassificationDTO {

    @ApiProperty()
    @IsOptional()
    assetsClassificationId?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Code not be empty" })
    assetsClassificationName: string;

    @ApiProperty({
        enum: AssetsCode
    })
    @IsOptional()
    @IsEnum(AssetsCode)
    assetCodeRequired?: AssetsCode;


    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    assetsClassificationCode: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    isActive: boolean;


    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    createdUser: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    updatedUser: string;


}